import {
  Drawer,
  DrawerOverlay,
  DrawerPortal,
  DrawerTrigger,
} from "@/components/ui/drawer";
import { LiquidPill } from "components/ui/v2";
import { LayoutPanelLeft, X } from "lucide-react";
import { useState } from "react";
import { Drawer as DrawerPrimitive } from "vaul";
import useTranslation from "next-translate/useTranslation";
import SidePanel from "./sidePanel";

interface ISidePanelMobileProps {
  render?: boolean;
}

/**
 * Trigger + panel derecho con los widgets del side-panel para resoluciones
 * por debajo de `WIDTH_2COL` (1140px).
 *
 * El panel ya no agrega una hoja/contenedor visual propio: los widgets flotan
 * sobre un backdrop global con blur, manteniendo el cierre por overlay/ESC y
 * un botón líquido de cierre.
 */
export default function SidePanelMobile(props: ISidePanelMobileProps) {
  const { render = false } = props;
  const { t } = useTranslation("common");
  const [open, setOpen] = useState(false);

  if (!render) {
    return null;
  }

  const close = () => setOpen(false);

  return (
    <Drawer
      direction="right"
      open={open}
      onOpenChange={setOpen}
      shouldScaleBackground={false}
    >
      <DrawerTrigger asChild>
        <LiquidPill
          as="button"
          type="button"
          variant="slate"
          appearance="normal"
          shape="circle"
          size="lg"
          hoverBounce
          hoverDeform
          shadow="default"
          icon={<LayoutPanelLeft className="h-5 w-5" strokeWidth={1.75} />}
          aria-label={t("Abrir panel de widgets") || "Abrir panel de widgets"}
        />
      </DrawerTrigger>

      <DrawerPortal>
        <DrawerOverlay
          onClick={close}
          className="bg-slate-950/35 backdrop-blur-md backdrop-saturate-150 dark:bg-black/55"
        />
        <DrawerPrimitive.Content
          className="fixed inset-0 z-50 outline-none"
          onPointerDown={close}
        >
          <div
            className="absolute right-3 top-3 z-10 sm:right-4 sm:top-4"
            onPointerDown={(event) => event.stopPropagation()}
          >
            <LiquidPill
              as="button"
              type="button"
              variant="slate"
              appearance="normal"
              shape="circle"
              size="md"
              reactive
              hoverBounce
              hoverDeform
              shadow="floating"
              icon={<X className="h-4 w-4" strokeWidth={1.9} />}
              onClick={close}
              aria-label={t("Cerrar") || "Cerrar"}
            />
          </div>

          <div
            className="ml-auto h-screen w-[min(360px,92vw)] overflow-y-auto px-3 pb-5 pt-16 sm:px-4 sm:pt-20"
            onPointerDown={(event) => event.stopPropagation()}
          >
            <SidePanel render={true} className="!mt-0" />
          </div>
        </DrawerPrimitive.Content>
      </DrawerPortal>
    </Drawer>
  );
}
